/**
 * news
 */
'use strict';
import AppNews from '@/_modules/app_news';

document.addEventListener('DOMContentLoaded', () => {
  new AppNews();
}, false);

window.addEventListener('load', () => {

}, false);

window.addEventListener('unload', () => {}, false);

window.addEventListener('pageshow', function(event){
  if (event.persisted) {
    window.location.reload();
  }
});
